import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomLogoIcon from '../components/common/CustomLogoIcon'
import { usePageTitle } from '../utils/util'

const NoPermission = () => {
    usePageTitle('AlkalmaUp - No permission')
    const history = useHistory()
    const { t } = useTranslation()

    return (
        <div className="absolute z-50 flex h-screen w-full flex-col items-center justify-center bg-deepOcean px-10 text-center">
            <CustomLogoIcon width={280} height={120} />
            <p className="mt-6 text-[28px] font-semibold text-textLight">{t('noPermissionTitle')}</p>
            <p className="mb-10 mt-4 max-w-[550px] text-[16px] text-textLight opacity-80">{t('noPermissionSubtitle')}</p>
            <button
                className="h-[60px] rounded-full bg-lightMint px-10 text-[18px] font-semibold text-textDark transition-opacity hover:opacity-90"
                onClick={() => history.push('/management')}
            >
                {t('goToUserManagement')}
            </button>
        </div>
    )
}

export default NoPermission
